export function inputAutoWidthDirective() {
  "njInject";
  return {
    scope: { value: '=' },
    link: function link($scope, $element) {
      var input = $element[0];
      if (input.nodeName !== 'INPUT') return console.warn("inputAutoWidthDirective must be used with <input>, got ".concat(input.nodeName));
      var measureEl = document.createElement("canvas");
      var measureElContext = measureEl.getContext("2d");
      measureElContext.font = $element.css('font');

      input.style.minWidth || (input.style.minWidth = '20px');
      input.addEventListener('input', onChange, false);
      input.addEventListener('paste', onChange, false);
      input.addEventListener('change', onChange, false);

      setTimeout(onChange);

      function onChange() {
        input.style.width = Math.ceil(
        measureElContext.measureText(String(input.value)).width + 18) +
        'px';
      }

      $scope.$watch('value', function (newValue, oldValue) {
        newValue !== oldValue ? onChange() : null;
      });

      return function () {
        input.removeEventListener('input', onChange);
        input.removeEventListener('paste', onChange);
        input.removeEventListener('change', onChange);
      };
    } };

}